import { render } from "./BatchCreate.vue?vue&type=template&id=ff5b5f6c&scoped=true"
import script from "./BatchCreate.vue?vue&type=script&lang=js"
export * from "./BatchCreate.vue?vue&type=script&lang=js"

import "./BatchCreate.vue?vue&type=style&index=0&id=ff5b5f6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5b5f6c"]])

export default __exports__